module.exports = __webpack_public_path__ + "static/media/intro-navigation.19e6b126.png";